import { render, staticRenderFns } from "./NewAccountBtn.vue?vue&type=template&id=cba15fee&scoped=true&"
import script from "./NewAccountBtn.vue?vue&type=script&lang=js&"
export * from "./NewAccountBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba15fee",
  null
  
)

export default component.exports